import { useParams, useSearchParams } from "react-router-dom";

import "./abertura.css";
import Menu from "../../components/menu/menu.jsx";
import Banco from "../../components/banco/banco.jsx";
import { useContext, useEffect, useState } from "react";
//import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import api from "../../services/api";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Receber from "../../components/receber/receber.jsx";
import Pagar from "../../components/pagar/pagar.jsx";
import Emprestimo from "../../components/emprestimo/emprestimo.jsx";
import Aplicacao from "../../components/aplicacao/aplicacao.jsx";
 
function Abertura(){
    //const params = useParams();
    const [searchParams    , setSearchParams]    = useSearchParams();
    const abaParam = searchParams.get("aba");
    const abaIndex = abaParam ? parseInt(abaParam, 10) : 0;
    const [tabIndex, setTabIndex] = useState(abaIndex);
    const [DadosBancos     , setDadosBancos]     = useState([]);
    const [DadosPagar      , setDadosPagar]      = useState([{}]);
    const [DadosReceber    , setDadosReceber]    = useState([{}]);
    const [DadosEmprestimo , setDadosEmprestimo] = useState([{}]);
    const [DadosAplicacao  , setDadosAplicacao]  = useState([{}]);
    const [DadosEncargos   , setDadosEncargos]   = useState([{}]);
    const [DadosEmpresa    , setDadosEmpresa]    = useState([]);
    var CNPJCliente = searchParams.get("cnpj");
    var usuario     = searchParams.get("usuario");

    // Array para controlar quais abas ficam desabilitadas
    const tabsDisabled = abaParam
        ? [true, true, true, true, true, true].map((v, i) => i !== abaIndex)
        : [false, false, false, false, false, false];    
    if (abaIndex >= 0 && abaIndex < tabsDisabled.length) {
        tabsDisabled[abaIndex] = false; // Só a aba escolhida fica habilitada
    }

    //roda quando a tela e carregada
    useEffect(()=>{
        //localStorage.setItem("cnpj","producao");
        //localStorage.setItem("usuario","MAX");
        RecuperaNomeCliente();
        MontarBancos();
        MontarAReceber();
        MontarAPagar();
        MontarEmprestimo();
        MontarAplicacao();
        MontarEncargos();
        
    },[]);


    // Agora pode fazer o retorno condicional
    // if (!CNPJCliente || CNPJCliente.trim() === "") {
    //     return (
    //         <div className="container mt-5">
    //             <div className="alert alert-warning" role="alert">
    //                 Por favor, informe o CNPJ para acessar esta página.
    //             </div>
    //         </div>
    //     );
    // }    

    // function fnPegaNomeCliente(){
    //     api.get("/erp/lead?CNPJ="+CNPJCliente+"&usuario="+usuario)  
    //     .then((resp) => {  //aguarda a resposta do comando get anterior
    //        console.log("Dados de bancos: " + JSON.stringify(resp.data));
    //     })
    //     .catch((err) => {     
    //                     console.log("Erro na pesquisa CNPJ");
    //                     console.log(err);
    //                     }
    //         );
    //     }
   
    const [nomeCliente, setNomeCliente] = useState("");

    useEffect(() => {
        RecuperaNomeCliente();
        MontarBancos();
        MontarAReceber();
        MontarAPagar();
        MontarEmprestimo();
        MontarAplicacao();
        MontarEncargos();
    }, []);

    function RecuperaNomeCliente() {
        if (!CNPJCliente) {
            console.log("CNPJ não informado");
            setNomeCliente("");
            return;
        }

        if (CNPJCliente === "producao") {
            setNomeCliente("Banco Produção");
            return;
        }

        api.get("/erp/lead?cnpj=" + CNPJCliente)
            .then((resp) => {
                setNomeCliente(resp.data.cont_nome || "");
                console.log("Nome Cliente:", resp.data.cont_nome);
            })
            .catch((err) => {
                console.log("Erro na pesquisa CNPJ", err);
                setNomeCliente("");
            });
    }

    function SalvarEncargos(){
        // Implementar a lógica para salvar o encargo
        api.post("/erp/encargos?CNPJ="+CNPJCliente+"&usuario="+usuario, {
            encargos: [{
                id: 0,
                descricao: 'Salários',
                dtvencto: document.getElementById(`vencimento-51`).value,
                valor: parseFloat(document.getElementById(`valor-51`).value),
                contaid: 51
            }, 
            {
                id: 1,
                descricao: 'INSS',
                dtvencto: document.getElementById(`vencimento-480`).value,
                valor: parseFloat(document.getElementById(`valor-480`).value),
                contaid: 480
            },
            {
                id: 2,
                descricao: 'IRRF',
                dtvencto: document.getElementById(`vencimento-479`).value,
                valor: parseFloat(document.getElementById(`valor-479`).value),
                contaid: 479
            },
            {
                id: 3,
                descricao: 'FGTS',
                dtvencto: document.getElementById(`vencimento-478`).value,
                valor: parseFloat(document.getElementById(`valor-478`).value),
                contaid: 478
            },
            {
                id: 4,
                descricao: 'Pensão',
                dtvencto: document.getElementById(`vencimento-477`).value,
                valor: parseFloat(document.getElementById(`valor-477`).value),
                contaid: 477
            }
        ]
        })
        .then((resp) => {
        console.log("Encargo salvo com sucesso");
        })
        .catch((err) => {
        console.log("Erro ao salvar encargo");
        });
    } 
    function MontarEncargos(){
             api.get("/erp/encargos?CNPJ="+CNPJCliente+"&usuario="+usuario)  
             .then((resp) => {  
               setDadosEncargos(resp.data);
             })
             .catch((err) => {
                 setDadosEncargos([{}]);
             });

    }
    function MontarBancos(){
             api.get("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+usuario)  
             .then((resp) => {  //aguarda a resposta do comando get anterior
                // console.log("Dados de bancos: " + JSON.stringify(resp.data));
               setDadosBancos(resp.data);
             })
             .catch((err) => {
                 //alert('Não foi possível carregar os bancos') ;
                 setDadosBancos([{}]);
             });    
     
         }         
    function NovoBanco(){
        // console.log('Antigo');
        // console.log(DadosBancos); cont_cnpj-1
        if (document.getElementById("bancoid_-1") !== null) {
            alert("Finalize o cadastro do último banco antes de adicionar um novo. Clique no botão no final da linha!");
            return;
        };
        setDadosBancos(DadosBancos => [...DadosBancos,{
            banco_id: -1,
            banco_agencia: null,
            banco_agencia_dv:null,
            banco_ativo: "S",
            banco_codigo:null,
            banco_conta: null,
            banco_conta_dv: null,
            banco_data_saldo:null,
            banco_nome: "",
            banco_saldo_inicial:0,
            banco_site: null,
            banco_tipo_conc: null,
            cod_agencia: null,
            cod_banco: null,
            conta_corrente: null,
            conta_id: null,
            ordem: 0}]) ;

        //  console.log('Novo');
        //  console.log(DadosBancos);
    }
    function MontarAPagar(){
        api.get("/erp/pagar?CNPJ="+CNPJCliente+"&usuario="+usuario)  
        //api.get("/erp/pagar?CNPJ="+param.cnpj+"&usuario="+param.usuario)  
        .then((resp) => {  //aguarda a resposta do comando get anterior

            // console.log("Dados de a pagar: " + JSON.stringify(resp.data.pagamentos));
            setDadosPagar(resp.data.pagamentos);

        })
        .catch((err) => {
            //alert('Não foi possível carregar "a pagar"') ;
            setDadosPagar(DadosPagar => [...DadosPagar,{
                cod_transacao: -1,
                cont_id: -1,
                trans_descr: null ,
                trans_dt_vencto: null,
                trans_valor: 0,
                trans_status: null,
                alterado: false,
                cont_cgc_cpf: "",
                cont_nome: null,
                cont_endereco: null,
                cont_numero: null,
                cont_complemento: null,
                cont_bairro: null,
                cont_cep: null,
                cont_cidade: null,
                cont_uf: null,
                cont_residencial: null,
                cont_email: null
            }]) ;
    

        });
    }
    function NovoPagar(){
        if (document.getElementById("cont_cnpj_pagar-1") !== null) {
            alert("Finalize o cadastro de a pagar antes de adicionar um novo. Clique no botão no final da linha!");
            return;
        };
        setDadosPagar(DadosPagar => [...DadosPagar,{
            cod_transacao: -1,
            cont_id: -1,
            trans_descr: null ,
            trans_dt_vencto: null,
            trans_valor: 0,
            trans_status: null,
            alterado: false,
            cont_cgc_cpf: "",
            cont_nome: null,
            cont_endereco: null,
            cont_numero: null,
            cont_complemento: null,
            cont_bairro: null,
            cont_cep: null,
            cont_cidade: null,
            cont_uf: null,
            cont_residencial: null,
            cont_email: null
        }]) ;

        //  console.log('Novo');
        //  console.log(DadosBancos);        
    }
    function MontarAReceber(){
        api.get("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+usuario)  
        .then((resp) => {  //aguarda a resposta do comando get anterior
            //alert(JSON.stringify(resp.data));
            // console.log("Json Receber: "+ JSON.stringify(resp.data.recebimentos));
            //AReceber = resp.data;
            // if (resp.data.recebimentos.length !== 0) {
                // console.log("Qtd a Receber: "+ resp.data.recebimentos.length);
                setDadosReceber(resp.data.recebimentos);
            // } else {
                // console.log("Sem dados a Receber");
                // setDadosReceber(DadosReceber => [...DadosReceber,{
                //     cod_transacao: -1,
                //     cont_id: -1,
                //     trans_descr: "" ,
                //     trans_dt_vencto: null,
                //     trans_valor: 0,
                //     trans_status: null,
                //     alterado: false,
                //     cont_cgc_cpf: "00000000000000",
                //     cont_nome: "",
                //     cont_endereco: null,
                //     cont_numero: null,
                //     cont_complemento: null,
                //     cont_bairro: null,
                //     cont_cep: null,
                //     cont_cidade: null,
                //     cont_uf: null,
                //     cont_residencial: null,
                //     cont_email: null
                // }]) ;
        
            // }
        })
        .catch((err) => {
            //alert('Não foi possível carregar "a receber"') ;
            // setDadosReceber([{}]);
                setDadosReceber(DadosReceber => [...DadosReceber,{
                    cod_transacao: -1,
                    cont_id: -1,
                    trans_descr: "" ,
                    trans_dt_vencto: null,
                    trans_valor: 0,
                    trans_status: null,
                    alterado: false,
                    cont_cgc_cpf: "00000000000000",
                    cont_nome: "",
                    cont_endereco: null,
                    cont_numero: null,
                    cont_complemento: null,
                    cont_bairro: null,
                    cont_cep: null,
                    cont_cidade: null,
                    cont_uf: null,
                    cont_residencial: null,
                    cont_email: null
                }]) ;
                    
        });
    }
    function NovoReceber(){
        if (document.getElementById("cont_cnpj-1") !== null) {
            alert("Finalize o cadastro de a receber antes de adicionar um novo. Clique no botão no final da linha!");
            return;
        };
        setDadosReceber(DadosReceber => [...DadosReceber,{
            cod_transacao: -1,
            cont_id: -1,
            trans_descr: null ,
            trans_dt_vencto: null,
            trans_valor: null,
            trans_status: null,
            alterado: false,
            cont_cgc_cpf: null,
            cont_nome: null,
            cont_endereco: null,
            cont_numero: null,
            cont_complemento: null,
            cont_bairro: null,
            cont_cep: null,
            cont_cidade: null,
            cont_uf: null,
            cont_residencial: null,
            cont_email: null
        }]) ;

        //  console.log('Novo');
        //  console.log(DadosBancos);        
    }
    function MontarEmprestimo(){
        api.get("/erp/emprestimo?CNPJ="+CNPJCliente+"&usuario="+usuario)  
        .then((resp) => {  //aguarda a resposta do comando get anterior
            //alert(JSON.stringify(resp.data));
            // console.log("Json Emprestimo: "+JSON.stringify(resp.data));
            //AReceber = resp.data;
            setDadosEmprestimo(resp.data.emprestimos);
        })
        .catch((err) => {
            //alert('Não foi possível carregar "Empréstimos"') ;
            setDadosEmprestimo([{}]);
        });
    }
    function NovoEmprestimo(){
        if (document.getElementById("cont_cnpj_emprestimo-1") !== null) {
            alert("Finalize o cadastro de empréstimo antes de adicionar um novo. Clique no botão no final da linha!");
            return;
        };
        setDadosEmprestimo(DadosEmprestimo => [...DadosEmprestimo,{
            cod_transacao: -1,
            cont_id: -1,
            trans_descr: null ,
            trans_dt_vencto: null,
            trans_valor: null,
            trans_status: null,
            alterado: false,
            cont_cgc_cpf: null,
            cont_nome: null,
            cont_endereco: null,
            cont_numero: null,
            cont_complemento: null,
            cont_bairro: null,
            cont_cep: null,
            cont_cidade: null,
            cont_uf: null,
            cont_residencial: null,
            cont_email: null
        }]) ;

        //  console.log('Novo');
        //  console.log(DadosBancos);        
    }
    function MontarAplicacao(){
        api.get("/erp/aplicacao?CNPJ="+CNPJCliente+"&usuario="+usuario)  
        .then((resp) => {  //aguarda a resposta do comando get anterior
            //alert(JSON.stringify(resp.data));
            // console.log(JSON.stringify(resp.data));
            //AReceber = resp.data;
            setDadosAplicacao(resp.data.aplicacoes);
        })
        .catch((err) => {
            //alert('Não foi possível carregar "Aplicações"') ;
            setDadosAplicacao([{
                cod_transacao: -1,
                cont_id: -1,
                trans_descr: null ,
                trans_dt_vencto: null,
                trans_valor: null,
                trans_status: null,
                alterado: false,
                cont_cgc_cpf: null,
                cont_nome: null,
                cont_endereco: null,
                cont_numero: null,
                cont_complemento: null,
                cont_bairro: null,
                cont_cep: null,
                cont_cidade: null,
                cont_uf: null,
                cont_residencial: null,
                cont_email: null}]);
        });
    }
    function NovoAplicacao(){
        // console.log('Novo Aplicacao');
        if (document.getElementById("cont_cnpj_aplicacao-1") !== null) {
            alert("Finalize o cadastro da aplicação antes de adicionar um novo. Clique no botão no final da linha!");
            return;
        };
        setDadosAplicacao(DadosAplicacao => [...DadosAplicacao,{
            cod_transacao: -1,
            cont_id: -1,
            trans_descr: null ,
            trans_dt_vencto: null,
            trans_valor: null,
            trans_status: null,
            alterado: false,
            cont_cgc_cpf: null,
            cont_nome: null,
            cont_endereco: null,
            cont_numero: null,
            cont_complemento: null,
            cont_bairro: null,
            cont_cep: null,
            cont_cidade: null,
            cont_uf: null,
            cont_residencial: null,
            cont_email: null
        }]) ;

        //  console.log(DadosBancos);        
    }
    function Atualizar(){
       // RecuperaNomeCliente(); 
        MontarBancos();
        MontarAReceber();
        MontarAPagar();
        MontarEmprestimo();
        MontarAplicacao();
        
        //MontarGrafico();

    }

    return <>
    <div className="container-fluid">
        <div className="row flex-nowrap">
            <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                <Menu page="abertura" />
            </div>

            <div className="col py-3 me-3">
                <div className="mb-5">
                    <h1>Procedimentos de Abertura</h1><h5>{nomeCliente}</h5>
                </div>                

                <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)} /* bloqueia troca de aba */>
                    <TabList>
                        <Tab disabled={tabsDisabled[0]}>Saldos Bancários</Tab>
                        <Tab disabled={tabsDisabled[1]}>Clientes a receber</Tab>
                        <Tab disabled={tabsDisabled[2]}>Fornecedores a pagar</Tab>
                        <Tab disabled={tabsDisabled[3]}>Empréstimos</Tab>
                        <Tab disabled={tabsDisabled[4]}>Aplicações</Tab>
                        <Tab disabled={tabsDisabled[5]}>Salários/Encargos</Tab>
                    </TabList>

                    <TabPanel>
                            <h2>Saldos Bancários</h2>
                            {/* <button onClick={() => MontarBancos()} className="btn btn-primary btn-sm" type="button" id="button-atualizar"><i className="bi bi-arrow-clockwise"></i></button> */}

                        <div className="row col-md-11">
                            <div className="col-md-1 text-left">Código</div>
                            <div className="col-md-3 text-left">Banco</div>
                            <div className="col-md-1 text-left">Agência</div>
                            <div className="col-md-1 text-left">Dígito</div>
                            <div className="col-md-2 text-left">Conta</div>
                            <div className="col-md-1 text-left">Dígito</div>
                            <div className="col-md-2 text-left">Saldo</div>
                            <div className="col-md-1 text-left"></div>
                        </div>
                        <div className="row col-md-11" id="div-bancos">
                        { }
                        {typeof(DadosBancos) !== 'undefined'? <>
                            {DadosBancos?.length > 0 ?<> 
                                {DadosBancos?.map(item => {                        //? = nao mapeia caso esteja vazio
                                    return item != null ? <Banco
                                            onClose={MontarBancos}
                                            key={item.banco_id}
                                            banco_id={item.banco_id}
                                            cod_banco={item.cod_banco}
                                            banco_nome={item.banco_nome}
                                            banco_agencia={item.banco_agencia}
                                            banco_agencia_dv={item.banco_agencia_dv}
                                            banco_conta={item.banco_conta}
                                            banco_conta_dv={item.banco_conta_dv}
                                            banco_saldo_inicial={item.banco_saldo_inicial}
                                            />
                                    : null
                                })}</>:<></>
                            }
                        </>:<></>
                        }
                        </div>            
                        <div>
                            <button className="btn btn-primary" onClick={NovoBanco}> Novo</button>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <h2>Clientes a receber</h2>

                        <div className="row col-md-11">
                            <div className="col-md-3 text-left">CNPJ</div>
                            <div className="col-md-4 text-left">Nome</div>
                            <div className="col-md-2 text-left">Vencimento</div>
                            <div className="col-md-2 text-left">Valor</div>
                            <div className="col-md-1 text-left"></div>
                        </div>
                        <div className="row col-md-11" id="div-receber">
                            {DadosReceber && DadosReceber.length > 0 &&
                                DadosReceber.map(item => (
                                    item != null ? <Receber
                                        onClose={MontarAReceber}
                                        key={item.cod_transacao}
                                        cod_transacao={item.cod_transacao}
                                        cont_cgc_cpf={item.cont_cgc_cpf}
                                        cont_nome={item.cont_nome}
                                        trans_dt_vencto={item.trans_dt_vencto}
                                        trans_valor={item.trans_valor}
                                    /> : null
                                ))
                            }
                        </div>            
                        <div>
                            <button className="btn btn-primary" onClick={NovoReceber}>Novo</button>
                        </div>                
                    </TabPanel>
                    <TabPanel>
                        <h2>Fornecedores a pagar</h2>
                        <div className="row col-md-11">
                            <div className="col-md-3 text-left">CNPJ</div>
                            <div className="col-md-4 text-left">Nome</div>
                            <div className="col-md-2 text-left">Vencimento</div>
                            <div className="col-md-2 text-left">Valor</div>
                            <div className="col-md-1 text-left"></div>
                        </div>
                        <div className="row col-md-11" id="div-pagar">
                            {/* {console.log("DadosPagar Length: "+DadosPagar.length)} */}
                            {((DadosPagar !== undefined) ||(DadosPagar?.length > 0)) ?<>
                                    {DadosPagar?.map(item => {                         
                                            console.log(item)
                                            return item != null ? <Pagar
                                            onClose={MontarAPagar}
                                            key={item.cod_transacao}
                                            cod_transacao={item.cod_transacao}
                                            cont_cgc_cpf={item.cont_cgc_cpf}
                                            cont_nome={item.cont_nome}
                                            trans_dt_vencto={item.item_dt_vencto}
                                            trans_valor={item.item_valor}
                                            />
                                        : null
                                    })} </>:<></>
                            }
                        </div>            
                        <div>
                            <button className="btn btn-primary" onClick={NovoPagar}>Novo</button>
                        </div>  
                    </TabPanel>
                    <TabPanel>
                        <h2>Empréstimos</h2>

                        <div className="row col-md-11">
                            <div className="col-md-4 text-left">CNPJ</div>
                            <div className="col-md-3 text-left">Instituição</div>
                            <div className="col-md-1 text-left">Dia</div>
                            <div className="col-md-1 text-left">Parc.</div>
                            <div className="col-md-2 text-left">Valor</div>
                            <div className="col-md-1 text-left"></div>
                        </div>
                        <div className="row col-md-11" id="div-emprestimo">
                            {((DadosEmprestimo == undefined) ||(DadosEmprestimo?.length > 0)) ?<>
                                    {DadosEmprestimo?.map(item => {    
                                        return item != null ? <Emprestimo
                                                onClose={MontarEmprestimo}
                                                key={item.cod_transacao}
                                                id={item.cod_transacao}
                                                cnpj={item.cont_cgc_cpf}
                                                cliente={item.cont_nome}
                                                vencimento={item.trans_dia_vencto} 
                                                parcelas={item.trans_num_parc}
                                                valor={item.trans_valor}

                                                />
                                        : null
                                    })} </>:<></>
                            }
                        </div>            
                        <div>
                            <button className="btn btn-primary" onClick={NovoEmprestimo}>Novo</button>
                        </div>                


                    </TabPanel>
                    <TabPanel>
                        <h2>Aplicações</h2>

                        <div className="row col-md-11">
                            <div className="col-md-3 text-left">CNPJ</div>
                            <div className="col-md-4 text-left">Instituição</div>
                            <div className="col-md-1 text-left">Dia</div>
                            <div className="col-md-1 text-left">Parc.</div>
                            <div className="col-md-2 text-left">Valor</div>
                            <div className="col-md-1 text-left"></div>
                        </div>
                        <div className="row col-md-11" id="div-aplicacao">
                            {((DadosAplicacao == undefined) ||(DadosAplicacao?.length > 0)) ?<>
                                    {DadosAplicacao?.map(item => {    
                                        return item != null ? <Aplicacao
                                                onClose={MontarAplicacao}
                                                key={item.cod_transacao}
                                                id={item.cod_transacao}
                                                cnpj={item.cont_cgc_cpf}
                                                cliente={item.cont_nome}
                                                vencimento={item.trans_dia_vencto} 
                                                parcelas={item.trans_num_parc}
                                                valor={item.trans_valor}

                                                />
                                        : null
                                    })} </>:<></>
                            }
                        </div>            
                        <div>
                            <button className="btn btn-primary" onClick={NovoAplicacao}>Novo</button>
                        </div>                


                    </TabPanel>
                    <TabPanel>
                        <h2></h2>

                        <div className="row col-md-11">
                            <div className="col-md-2 text-left"></div>
                            <div className="col-md-2 text-left">Vencimento</div>
                            <div className="col-md-2 text-left">Valor</div>
                            <div className="col-md-2 text-left"></div>
                            <div className="col-md-3 text-left"></div>
                        </div>
                        <div className="row col-md-11" id="div-encargos">
                        {Array.isArray(DadosEncargos) ? DadosEncargos.map((encargo, idx) => (
                            <div className="row align-items-center mb-2" key={encargo.contaid ?? idx}>
                                <div className="col-md-2">{encargo.nome}</div>
                                <div className="col-md-2">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id={`vencimento-${encargo.contaid ?? idx}`}
                                        value={encargo.vencimento || ''}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id={`valor-${encargo.contaid ?? idx}`}
                                        min="0"
                                        step="1.00"
                                        value={encargo.valor || 0}
                                    />
                                </div>
                                <div className="col-md-2">
                                    {/* <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            const valor = document.getElementById(`valor-${encargo.contaid ?? idx}`).value;
                                            const dataVenc = document.getElementById(`vencimento-${encargo.contaid ?? idx}`).value;
                                            SalvarEncargo(encargo.contaid ?? idx, valor, dataVenc);
                                        }}
                                    >
                                        Salvar
                                    </button> */}
                                </div>
                            </div>
                        )) : null}</div>
                        <div>
                            <button className="btn btn-primary" onClick={SalvarEncargos}>Salvar</button>
                        </div>                


                    </TabPanel>            
                </Tabs>


                
            </div>
        </div>
    </div>
</>
}

export default Abertura;
